import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/Education/Hero";
import IndustriesContent from "../components/Education/IndustriesContent";
import PageTitle from "../components/Education/PageTitle";

import '../assets/Webdevelopment.css';



const Education = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<IndustriesContent />
	  	</div>
	)
}

export default Education;
